import React from 'react'
import { TextField } from '@material-ui/core'

export const SimpleInput = ({ inputRef = () => { }, ref, InputProps, ...other }) => (
  <TextField
    fullWidth
    margin='normal'
    InputProps={{
      inputRef: node => {
        ref(node);
        inputRef(node);
      },
      ...InputProps,
    }}
    {...other}
  />
)


// WEBPACK FOOTER //
// ./src/components/Autocomplete/components/SimpleInput/SimpleInput.js